<template>
    <div ref="container">
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('payment_info')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('payment_info')" :isFilter="false"/>
            </template>
            <div v-if="data!=null && data.customer!=null">
                <div class="border px-5 pt-5 mb-5 rounded">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-3 ellipsis-1"><label
                            class="col-form-label mr-1 p-0">{{ $t('student_number') }}:</label>{{
                                data.customer.number
                                                                                               }}
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-3 ellipsis-1"><label
                            class="col-form-label mr-1 p-0">{{ $t('name_surname') }}:</label>{{ data.customer.name }}
                                                                                             {{ data.customer.surname }}
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-3 ellipsis-1"><label
                            class="col-form-label mr-1 p-0">{{ $t('faculty') }}:</label>{{ data.customer.faculty_name }}
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-3 ellipsis-1"><label
                            class="col-form-label mr-1 p-0">{{ $t('program') }}:</label>{{ data.customer.program_name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-5 d-flex" v-if="data!=null && data.customer!=null">
                <b-button variant="outline-primary mr-3" @click="onlinePayment"><span
                    class="d-flex"><i class="ri-add-line mr-2"></i>{{ $t('make_payment') | toUpperCase }}</span></b-button>
            </div>
            <b-tabs content-class="py-5 position-relative"
                  v-if="data!=null && data.customer.student_type=='mentora' && data.session_periods!=null">
            <div class="tabs-bottom-line"></div>
            <b-tab v-for="year in Object.keys(data.session_periods).reverse()" v-bind:key="year">
              <template #title><span class="d-flex align-items-center"><i class="ri-calendar-line top-plus-1 mr-2"></i>{{ year }}</span></template>
              <b-tabs content-class="py-5 position-relative">
                <div class="tabs-bottom-line"></div>
                <b-tab v-for="month in Object.keys(data.session_periods[year])" v-bind:key="month">
                  <template #title><span class="d-flex align-items-center">{{ month }}</span></template>

                  <b-tabs content-class="py-5 position-relative">
                    <div class="tabs-bottom-line"></div>
                    <b-tab v-for="(session, index) in data.sessions[year][month]" v-bind:key="session.id" :active="index===0">
                      <template #title><span class="d-flex align-items-center">{{ session.course_name }} - {{session.start_date}}</span></template>
                      <div v-if="data.session_payment_plans && data.session_payment_plans[session.id]">
                        <div v-for="plan in data.session_payment_plans[session.id]" v-bind:key="plan.id" :accesskey="plan.printId='0'">
                          <h6 class="text-uppercase mb-4">{{ plan.product.name.toUpper() }}</h6>
                          <b-table
                              bordered
                              striped
                              responsive
                              :items="[plan]"
                              :fields="getPriceFields(plan)"
                              class="mb-2 table-dropdown no-scrollbar border rounded">
                            <template #cell(gross_price)="row">
                              <div v-if="row.item.credits>0">
                                {{ row.item.gross_price | formatToCurrency(row.item.currency) }} ({{row.item.gross_price/row.item.credits | formatToCurrency(row.item.currency)}} x  {{row.item.credits}} credits)
                              </div>
                              <div v-else>
                                {{ row.item.gross_price | formatToCurrency(row.item.currency) }}
                              </div>
                            </template>
                            <template #cell(price)="row">
                              <div v-if="row.item.credits>0 && false">
                                {{ row.item.price | formatToCurrency(row.item.currency) }} ({{row.item.price/row.item.credits | formatToCurrency(row.item.currency)}} x  {{row.item.credits}} credits)
                              </div>
                              <div v-else>
                                {{ row.item.price | formatToCurrency(row.item.currency) }}
                              </div>
                            </template>
                            <template #cell(total_discount)="row">
                              <div v-if="row.item.credits>0">
                                <div v-if="row.item.credit_based_discount_amount>0">
                                  {{ row.item.total_discount | formatToCurrency(row.item.currency) }} ({{row.item.credit_based_discount_amount | formatToCurrency(row.item.currency)}} x  {{row.item.credits}} credits)
                                  {{row.item.non_credit_based_discount_amount>0?' + ':''}}
                                </div>
                                <div v-else-if="row.item.non_credit_based_discount_amount>0">
                                  {{row.item.non_credit_based_discount_amount | formatToCurrency(row.item.currency)}}
                                </div>
                                <div v-else>
                                  {{ row.item.total_discount | formatToCurrency(row.item.currency) }}
                                </div>
                              </div>
                              <div v-else>
                                {{ row.item.total_discount | formatToCurrency(row.item.currency) }}
                              </div>
                            </template>
                            <template #cell(cash_discount)="row">
                              {{ row.item.cash_discount_rate }}% ({{row.item.price - row.item.cash_price | formatToCurrency(row.item.currency)}})
                            </template>
                            <template #cell(cash_price)="row">
                              <div :class="row.item.is_cash && row.item.payments.length>0?'badge badge-danger':''">
                                {{ row.item.cash_price | formatToCurrency(row.item.currency) }}
                              </div>
                            </template>
                          </b-table>
                          <b-table
                              v-if="plan.payments.length>0"
                              bordered
                              striped
                              responsive
                              :items="plan.payments"
                              :fields="paymentFields"
                              show-empty
                              class="mb-5 table-dropdown no-scrollbar border rounded">
                            <template #cell(due_date)="row">
                              <div v-if="row.item.parent_id!=null">
                              </div>
                              <div v-else>
                                {{ row.item.due_date | dateFormat }}
                              </div>
                            </template>
                            <template #cell(amount)="row">
                                <span v-if="row.item.parent_id==null">{{
                                    row.item.amount | formatToCurrency(plan.currency)
                                  }}</span>
                            </template>
                            <template #cell(status)="row">
                                <span v-if="row.item.is_paid"
                                      class="badge badge-success">Paid
                                </span>
                              <span v-else
                                    class="badge badge-danger">Pending
                                </span>
                            </template>
                            <template slot="bottom-row">
                              <td>

                              </td>
                              <td></td>
                              <td><b>
                                {{ plan.payments_sum_amount | formatToCurrency(plan.currency) }}</b></td>
                              <td><b>{{ plan.paid | formatToCurrency(plan.currency) }}</b></td>
                              <td><b>{{ $t('balance') }}:</b> <b :class="plan.balance<0?'text-danger':''">{{
                                  plan.balance | formatToCurrency(plan.currency)
                                }}</b>
                              </td>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
            <b-tabs content-class="py-5 position-relative"
                    v-if="data!=null && data.periods!=null">
                <div class="tabs-bottom-line"></div>
                <b-tab v-for="period in data.periods" v-bind:key="period.code">
                    <template #title>
                        <span class="d-flex align-items-center">
                            <i class="ri-calendar-line top-plus-1 mr-2"></i>
                            {{ period.semester_name }}
                        </span>
                    </template>
                    <div v-if="period.code=='Housing'">
                        <div v-for="reservation in data.housing" v-bind:key="reservation.id">
                            <h6 class="mb-4">
                                <span class="badge badge-info mr-2 font-size-15">Date: <span class="text-black-75">{{ reservation.check_in_date }} - {{ reservation.check_out_date }}</span></span>
                                <span class="badge badge-info mr-2 font-size-15">Room: <span class="text-black-75">{{reservation.housing_bed.room.name}} / {{reservation.housing_bed.room.type_name}}</span></span>
                                <span class="badge badge-info mr-2 font-size-15">Fee: <span class="text-black-75">{{currencyFormat(parseFloat(reservation.fee - reservation.discount_amount))}}</span></span>
                                <span class="badge badge-info font-size-15">Balance: <span class="text-black-75">{{currencyFormat(parseFloat(reservation.pending_amount))}}</span></span>
                            </h6>
                            <b-table
                                v-if="reservation.payments.length>0"
                                bordered
                                striped
                                responsive
                                :items="reservation.payments"
                                :fields="housingPaymentFields"
                                show-empty
                                class="mb-5 table-dropdown no-scrollbar border rounded">
                                <template #cell(amount)="row">
                                    {{row.item.amount | formatToCurrency(reservation.currency)}}
                                </template>
                                <template #cell(amount_paid)="row">
                                    {{row.item.is_paid?row.item.amount:0 | formatToCurrency(reservation.currency)}}
                                </template>
                                <template #cell(balance)="row">
                                    {{row.item.is_paid?0:row.item.amount | formatToCurrency(reservation.currency)}}
                                </template>
                                <template #cell(payment_type_name)="row">
                                    {{row.item.payment_type?.name}}
                                </template>
                                <template #cell(product)="row">
                                    {{row.item.product?.name}}
                                </template>


                                <template #cell(status)="row">
                                    <span v-if="row.item.is_paid"
                                          class="badge badge-success">Paid
                                    </span>
                                    <span v-else
                                          class="badge badge-danger">Pending
                                    </span>
                                </template>
                            </b-table>
                        </div>
                    </div>
                    <div v-else v-for="plan in data.payment_plans[period.code]" v-bind:key="plan.id">
                        <h6 class="text-uppercase mb-4">{{ plan.product.name | toUpperCase }}</h6>
                        <b-table
                            bordered
                            striped
                            responsive
                            :items="[plan]"
                            :fields="getPriceFields(plan)"
                            class="mb-4 table-dropdown no-scrollbar border rounded">
                          <template #cell(gross_price)="row">
                            <div v-if="row.item.credits>0">
                              {{ row.item.gross_price | formatToCurrency(row.item.currency) }} ({{row.item.gross_price/row.item.credits | formatToCurrency(row.item.currency)}} x  {{row.item.credits}} credits)
                            </div>
                            <div v-else>
                              {{ row.item.gross_price | formatToCurrency(row.item.currency) }}
                            </div>
                          </template>
                          <template #cell(price)="row">
                            <div v-if="row.item.credits>0 && false">
                              {{ row.item.price | formatToCurrency(row.item.currency) }} ({{row.item.price/row.item.credits | formatToCurrency(row.item.currency)}} x  {{row.item.credits}} credits)
                            </div>
                            <div v-else>
                              {{ row.item.price | formatToCurrency(row.item.currency) }}
                            </div>
                          </template>
                          <template #cell(total_discount)="row">
                            <div v-if="row.item.credits>0">
                              <div v-if="row.item.credit_based_discount_amount>0">
                                {{ row.item.total_discount | formatToCurrency(row.item.currency) }} ({{row.item.credit_based_discount_amount | formatToCurrency(row.item.currency)}} x  {{row.item.credits}} credits)
                                {{row.item.non_credit_based_discount_amount>0?' + ':''}}
                              </div>
                              <div v-else-if="row.item.non_credit_based_discount_amount>0">
                                {{row.item.non_credit_based_discount_amount | formatToCurrency(row.item.currency)}}
                              </div>
                              <div v-else>
                                {{ row.item.total_discount | formatToCurrency(row.item.currency) }}
                              </div>
                            </div>
                            <div v-else>
                              {{ row.item.total_discount | formatToCurrency(row.item.currency) }}
                            </div>
                          </template>
                          <template #cell(cash_discount)="row">
                            {{ row.item.cash_discount_rate }}% ({{row.item.price - row.item.cash_price | formatToCurrency(row.item.currency)}})
                          </template>
                          <template #cell(cash_price)="row">
                            <div :class="row.item.is_cash && row.item.payments.length>0?'badge badge-danger':''">
                              {{ row.item.cash_price | formatToCurrency(row.item.currency) }}
                            </div>
                          </template>
                        </b-table>
                        <b-table
                            v-if="plan.payments.length>0"
                            bordered
                            striped
                            responsive
                            :items="plan.payments"
                            :fields="paymentFields"
                            show-empty
                            class="mb-5 table-dropdown no-scrollbar border rounded">
                            <template #cell(due_date)="row">
                                <a class="ri-arrow-right-s-line"
                                   v-if="row.item.parent_id!=null"></a>{{ row.item.due_date | dateFormat }}
                            </template>
                            <template #cell(amount)="row">
                                <span v-if="row.item.parent_id==null">{{
                                        row.item.amount | formatToCurrency(plan.currency)
                                                                      }}</span>
                            </template>
                            <template #cell(amount_paid)="row">
                                <span v-if="row.item.is_paid && !row.item.has_sub_payments">{{
                                        row.item.amount | formatToCurrency(plan.currency)
                                                                                            }}</span>
                            </template>
                            <template slot="bottom-row">
                                <td></td>
                                <td><b>
                                    {{ plan.payments_sum_amount | formatToCurrency(plan.currency) }}</b></td>
                                <td><b>{{ plan.paid | formatToCurrency(plan.currency) }}</b></td>
                                <td><b>{{ $t('balance') }}: {{ plan.balance | formatToCurrency(plan.currency) }}</b>
                                </td>
                            </template>
                        </b-table>
                        <b-table
                            v-if="plan.refunds.length>0"
                            bordered
                            striped
                            responsive
                            :items="plan.refunds"
                            :fields="refundFields"
                            show-empty
                            class="mb-5 table-dropdown no-scrollbar border rounded">
                        </b-table>
                    </div>
                </b-tab>
            </b-tabs>
        </app-layout>
    </div>
</template>
<script>
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
    import CustomerService from '@/services/CustomerService';
    import Base from '@/plugins/Base';

    export default {
        name: 'StudentPayments',
        props: {},
        components: {
            AppLayout,
            Header,
            HeaderMobile
        },
        data() {
            return {
                student_program_id: this.$route.params.student_program_id,
                data: null,
                priceFields: [
                  {
                    key: 'gross_price',
                    label: this.toUpperCase('gross_price'),
                    sortable: true,
                    formatter: this.formatToCurrency
                  },
                  {
                    key: 'total_discount',
                    label: this.toUpperCase('total_discount'),
                    sortable: true,
                    formatter: this.formatToCurrency
                  },
                  {
                    key: 'price',
                    label: this.toUpperCase('price'),
                    sortable: true,
                    formatter: this.formatToCurrency
                  },
                  {
                    key: 'cash_discount',
                    label: this.toUpperCase('cash_discount'),
                    sortable: true,
                  },
                  {
                    key: 'due_date',
                    label: this.toUpperCase('due_date'),
                    sortable: true,
                    formatter: this.formatDate
                  },
                ],
                housingPriceFields: [
                    {
                        key: 'total_amount',
                        label: this.toUpperCase('total_amount'),
                        sortable: true,
                        formatter: this.formatToCurrency
                    },
                    {
                        key: 'paid',
                        label: this.toUpperCase('paid'),
                        sortable: true,
                        formatter: this.formatToCurrency
                    },
                    {
                        key: 'balance',
                        label: this.toUpperCase('balance'),
                        sortable: true,
                        formatter: this.formatToCurrency
                    }
                ],
                housingPaymentFields: [
                    {
                        key: 'product',
                        label: this.toUpperCase('fee'),
                        thClass: 'width-150'
                    },
                    {
                        key: 'due_date',
                        label: this.toUpperCase('due_date'),
                        formatter: this.formatDate,
                        thClass: 'width-150'
                    },
                    {
                        key: 'amount',
                        label: this.toUpperCase('amount_to_be_paid'),
                    },
                    {
                        key: 'amount_paid',
                        label: this.toUpperCase('amount_paid'),
                    },
                    {
                        key: 'balance',
                        label: this.toUpperCase('balance'),
                    },
                    {
                        key: 'payment_date',
                        label: this.toUpperCase('payment_date'),
                        formatter: this.formatDate,
                        thClass: 'width-150'
                    },
                    {
                        key: 'status',
                        label: this.toUpperCase('status'),
                    },
                    {key: 'payment_type_name', label: this.toUpperCase('payment_type')}
                ],
                paymentFields: [
                    {
                        key: 'due_date',
                        label: this.toUpperCase('due_date'),
                        formatter: this.formatDate
                    },
                    {
                        key: 'amount',
                        label: this.toUpperCase('amount_to_be_paid'),
                        formatter: this.formatToCurrency
                    },
                    {
                        key: 'amount_paid',
                        label: this.toUpperCase('amount_paid'),
                        formatter: this.formatToCurrency
                    },
                    {
                        key: 'payment_date',
                        label: this.toUpperCase('payment_date'),
                        formatter: this.formatDate
                    },
                ],
                refundFields: [
                    {
                        key: 'refund_date',
                        label: this.toUpperCase('refund_date'),
                        formatter: this.formatDate
                    },
                    {
                        key: 'amount',
                        label: this.toUpperCase('refund_amount'),
                        formatter: this.formatToCurrency
                    },
                ]
            }
        },
        created() {
            this.loadData();
        },
        methods: {
            getPriceFields(plan) {
              return this.priceFields.filter((field)=>{
                if(field.key=='gross_price' && plan.product.apply_scholarship==false){
                  return false;
                }
                else if(field.key=='total_discount' && plan.product.apply_scholarship==false){
                  return false;
                }
                else if(field.key=='cash_discount' && !plan.cash_discount_rate){
                  return false;
                }
                return true;
              });
            },
            loadData() {
                if (typeof this.student_program_id == 'undefined') {
                    this.student_program_id = 0;
                }
                CustomerService.getMyPayments(this.student_program_id)
                               .then(this.dataCallback)
                               .catch(e => {
                                   this.showErrors(e);
                               })
            },
            dataCallback(response) {
                this.data = response.data.data;
            },

            formatToCurrency(value, key, item) {
                return this.$options.filters.formatToCurrency(value, item.currency);
            },
            formatDate(value) {
                return this.$options.filters.dateFormat(value);
            },
            onlinePayment() {
                let data = {customer_id: this.data.customer.id, student_program_id: this.student_program_id};
                CustomerService.createEpaymentLogin(data)
                               .then(response => {
                                   let data = response.data.data;
                                   Base.LocalStorage.set('epayment_token', data.token);
                                   this.$store.commit('epayment/setEpaymentToken', 'Bearer ' + data.token);
                                   Base.LocalStorage.set('epayment_user', data.customer);
                                   this.$store.commit('epayment/setEpaymentUser', data.customer)
                                   this.$router.push('/epayment');
                               })
                               .catch(e => {
                                   this.showErrors(e);
                               })
            }
        }
    }
</script>
